import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {antiWebHookApi} from '../../../../http/Api';
import StatusTemplateDomain from '../../../template/status/statusBlock/StatusTemplateDomain';
import WhiteListComponent from '../../../template/status/whiteList/WhiteListComponent';
import NotificationTamplateBlock from '../../../template/status/notifications/NotificationTamplateBlock';
import NotificationTamplateBlockPlug from '../../../template/status/notifications/NotificationTamplateBlockPlug';
import PopUpSubscribeTamplate from '../../../template/popUp/PopUpSubscribeTamplate';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import {useChanges} from '../../../../hooks/useChanges';
import {getAntiWebHook} from '../../../../store/AntiWebHook';
import './antiWebhook.scss';

const StatusAntiWebhook = () => {
  const {handleSaveChanges, cancelChanges} = useChanges();
  const [isSubscribe, setIsSubscribe] = useState(false);
  const {antiWebHookGlobalState} = useSelector((state) => state.antiWebHook);
  const {changesDetected} = useSelector((state) => state.changeDetected);
  const [isPopUpSubscribe, setIsPopUpSubscribe] = useState(antiWebHookGlobalState?.data?.premium);

  return (
    <div className="setting_component_wrap">
      <div className="overview_component_content_head">
        <h4>Anti-Webhook</h4>
        <p>
          Prevent unauthorized access and malicious activity by blocking any attempts to use webhook
          to send messages to a Discord server.
        </p>
      </div>
      <div className="status_antiwebhook_content">
        <StatusTemplateDomain data={antiWebHookGlobalState} />
        <WhiteListComponent data={antiWebHookGlobalState} />
        {!isSubscribe ? (
          <NotificationTamplateBlockPlug setIsPopUpSubscribe={setIsPopUpSubscribe} />
        ) : (
          <NotificationTamplateBlock data={antiWebHookGlobalState?.data} />
        )}
        {isPopUpSubscribe && (
          <PopUpSubscribeTamplate
            setIsSubscribe={setIsSubscribe}
            setIsPopUpSubscribe={setIsPopUpSubscribe}
          />
        )}
        {changesDetected && (
          <ChangeDetectedItem
            cancel={cancelChanges}
            onSave={() => handleSaveChanges(antiWebHookApi.updateAntiWebHook, getAntiWebHook)}
          />
        )}
      </div>
    </div>
  );
};

export default StatusAntiWebhook;
